import styled from "styled-components";

export const LoadingContainer = styled.section`
	width: 100%;
	min-height: 3rem;
	height: inherit;
	display: flex;
	justify-content: center;
	align-items: center;

	> span {
		width: 3.2vw;
		height: 3.2vw;
		border-radius: 50%;
		display: inline-block;
		position: absolute;
		left: 50%;
		margin-left: -2vw;
		animation: 3s infinite linear;
		&:nth-child(1) {
			background: #ff5a00;
			animation: kiri 1.2s infinite linear;
		}
		&:nth-child(2) {
			background: #3e82f7;
		}
		&:nth-child(3) {
			background: #fcb904;
			animation: kankan 1.2s infinite linear;
		}
	}

	@keyframes kiri {
		0% {
			transform: translateX(-4vw);
		}
		50% {
			transform: translateX(4vw);
		}
		100% {
			transform: translateX(-4vw);
		}
	}

	@keyframes kankan {
		0% {
			transform: translateX(4vw);
		}
		50% {
			transform: translateX(-4vw);
		}
		100% {
			transform: translateX(4vw);
		}
	}
`;
